import * as React from 'react';
import { observer } from 'mobx-react';
import { classes } from '../../utils/Classes';
import { SHADE_INFO_POSITION_TYPE } from '../../constants/ShadeInfoPositionType';
import { Column } from 'elc-grid';
import styled from 'styled-components';
import { ContentSpacing } from 'elc-base-theme';
import { MPP_SHADE_NAME } from '../../constants/DataTestIdAttributes';
import { Shade } from '../../domain/entities/Shade';
import { ProductShadeDescription } from './ProductShadeDescription';
import { Subtitle3 } from 'elc-typography';

interface IProductShadeInfoProps {
    shade?: Shade;
    descriptionPosition?: SHADE_INFO_POSITION_TYPE;
    namePosition?: SHADE_INFO_POSITION_TYPE;
}

interface IColorTitleProps {
    color?: string;
}

const ColorTitle = styled(Subtitle3)`
    color: ${({ color }: IColorTitleProps) => color};
    line-height: 1;
    max-height: 3em;
    overflow: hidden;
    margin: ${ContentSpacing.space4} 0;
`;

@observer
export class ProductShadeInfo extends React.Component<IProductShadeInfoProps> {
    public getShadeInfoClasses = () => {
        const { namePosition } = this.props;

        return classes(`shade-info-${namePosition}`);
    };

    public render() {
        const { shade, descriptionPosition, namePosition } = this.props;
        const shadeDescriptionAboveName = descriptionPosition === SHADE_INFO_POSITION_TYPE.ABOVE;
        const shadeDescriptionBelowName = descriptionPosition === SHADE_INFO_POSITION_TYPE.BELOW;
        const shadeDescriptionInline = descriptionPosition === SHADE_INFO_POSITION_TYPE.INLINE;
        const displayShadeInfo = namePosition !== SHADE_INFO_POSITION_TYPE.NONE;
        const shadePickerTitleClassNames = classes('product-shade-picker-title');
        const shadeNameClassNames = classes('product-shade-name');
        const shadeNameColor = (shade && shade.hexVal) || (shade && shade.colors[0]);
        const displayShadeName = displayShadeInfo && shade && shade.name;
        const shadeName = shade && shade.name;

        const shadeInfo = (
            <>
                {shadeDescriptionAboveName && (
                    <ProductShadeDescription shade={shade} position={descriptionPosition} />
                )}
                {displayShadeName && (
                    <ColorTitle color={shadeNameColor} className={shadeNameClassNames}>
                        {shadeName}
                    </ColorTitle>
                )}
                {(shadeDescriptionInline || shadeDescriptionBelowName) && (
                    <ProductShadeDescription shade={shade} position={descriptionPosition} />
                )}
            </>
        );

        return (
            <Column className={this.getShadeInfoClasses()}>
                <div data-test-id={MPP_SHADE_NAME} className={shadePickerTitleClassNames}>
                    {shadeInfo}
                </div>
            </Column>
        );
    }
}
